export default {
  name: 'Footer'
}
